import { BroadcastChannel } from 'broadcast-channel';
import { decode } from 'jwt-simple';

export const BROADCAST_MESSAGES = {
  ACCESS_TOKEN_SET: 'ACCESS_TOKEN_SET',
  ACCESS_TOKEN_REMOVE: 'ACCESS_TOKEN_REMOVE'
};

const MESSAGE_DELAY = 50; // ms

export const TokenUtil = {
  getBroadcastChannel: (): BroadcastChannel<string> =>
    new BroadcastChannel('nzcer-assist-token-utils'),
  getRefreshToken: (): string => localStorage.getItem('refresh_token') || '',
  setRefreshToken: (token: string): void => {
    localStorage.setItem('refresh_token', token);
  },
  removeRefreshToken: (): void => {
    localStorage.removeItem('refresh_token');
  },
  getAccessToken: (): string => localStorage.getItem('access_token') || '',
  getAccessTokenCustomer: (): { id: number; name: string } | undefined => {
    const token = TokenUtil.getAccessToken();
    // only decode the token when we actually have one
    if (token) return decode(token, null, true).customer;
    return undefined;
  },
  setAccessToken: (token: string): void => {
    localStorage.setItem('access_token', token);
    setTimeout(
      () => TokenUtil.getBroadcastChannel().postMessage(BROADCAST_MESSAGES.ACCESS_TOKEN_SET),
      MESSAGE_DELAY
    );
  },
  removeAccessToken: (): void => {
    localStorage.removeItem('access_token');
    setTimeout(
      () => TokenUtil.getBroadcastChannel().postMessage(BROADCAST_MESSAGES.ACCESS_TOKEN_REMOVE),
      MESSAGE_DELAY
    );
  },
  backupTokens: (): void => {
    const accessToken = TokenUtil.getAccessToken();
    const refreshToken = TokenUtil.getRefreshToken();
    localStorage.setItem('backup.access_token', accessToken);
    localStorage.setItem('backup.refresh_token', refreshToken);
  },
  restoreTokens: (): void => {
    const accessToken = TokenUtil.getBackupAccessToken();
    const refreshToken = TokenUtil.getBackupRefreshToken();
    TokenUtil.setAccessToken(accessToken);
    TokenUtil.setRefreshToken(refreshToken);
    TokenUtil.removeBackupTokens();
  },
  removeBackupTokens: (): void => {
    localStorage.removeItem('backup.access_token');
    localStorage.removeItem('backup.refresh_token');
  },
  getBackupAccessToken: (): string => localStorage.getItem('backup.access_token') || '',
  getBackupRefreshToken: (): string => localStorage.getItem('backup.refresh_token') || ''
};
